import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {contentUrlSolver, formatContentDuration} from '../../helpers';

import {Container} from './VideosGrid.styles';

import ContentBox from '../ContentBox';

function VideosGrid({
    items,
    onClickItem,
    isFavouritesGrid,
    renderInterval,
    onlyChild,
    hideDuration,
    hidePlayButton,
    cnito,
    noHilite,
}) {
    const {t} = useTranslation();

    const config = useSelector(state => state.config);

    const renderContent = items.map((item, index) => {
        if (renderInterval) {
            if (index + 1 < renderInterval[0] || index + 1 > renderInterval[1])
                return <div key={`${item.id}_${index}`}></div>;
        }

        return (
            <ContentBox
                key={`${item.id}_${index}`}
                id={item.id}
                data={item}
                favouritesGrid={isFavouritesGrid}
                duration={!hideDuration && formatContentDuration(item.duration)}
                isEpisode
                highlight={item.highlight}
                background={contentUrlSolver(
                    config,
                    item.image,
                    'THUMBNAIL',
                    '?imwidth=300',
                )}
                title={item.show?.title || item.title}
                sub={
                    (item.show?.title || '').toLowerCase() !==
                    item.title.toLowerCase()
                        ? item.title
                        : t('video.titleFormat')
                              .replace('{season}', item.season)
                              .replace('{episode}', item.episode)
                }
                action={() => onClickItem(item.id, item)}
                hidePlayButton={hidePlayButton}
                cnito={cnito}
            />
        );
    });

    return onlyChild ? (
        renderContent
    ) : (
        <Container id="videos-grid" cnito={cnito} noHilite={noHilite}>
            {renderContent}
        </Container>
    );
}

export default VideosGrid;
